/* eslint-disable react/prop-types */
import withAuthenticator from 'HOCs/withAuthenticator';
import React from 'react';
import { ROLES } from 'utils/authorization';
import StudentHome from './Student/Home';
import TeacherHome from './Teacher/Home';

function HomePage({ loggedInUser }) {
  const isStudent = loggedInUser.role === ROLES.STUDENT || loggedInUser.role === ROLES.MANAGER;
  const isTeacher = loggedInUser.role === ROLES.TEACHER;
  return (
    <React.Fragment>
      {isStudent && <StudentHome />}
      {isTeacher && <TeacherHome />}
    </React.Fragment>
  );
}

export default withAuthenticator(HomePage);
